import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { ConversationToAddressActivityMessage } from './conversation-to-address-activity-message';
import { CreateConversationActivityMessage } from './create-conversation-activity-message';
import { CreateConversationLabelActivityMessage } from './create-conversation-label-activity-message';
import { DeleteConversationLabelActivityMessage } from './delete-conversation-label-activity-message';
import { ExecuteBehaviorActivityMessage } from './execute-behavior-activity-message';
import { ExecuteMacroActivityMessage } from './execute-macro-activity-message';
import { UpdateConversationActivityMessage } from './update-conversation-activity-message';

/**
 * One activity as a flat row — the entity/operation dispatch and nothing else. Kept free of the
 * nesting concern so a surface that only wants a row is not handed a collapsible run; `ActivityRun`
 * uses it for its own header.
 */
export const ActivityRow = ({ activity }: { activity: ActivityFeed }) => {
  switch (activity.entity) {
    case 'Conversation':
      switch (activity.activityType) {
        case 'create':
          return <CreateConversationActivityMessage activity={activity} />;
        case 'update':
          return <UpdateConversationActivityMessage activity={activity} />;
        default:
          return null;
      }
    case 'ConversationToAddress':
      switch (activity.activityType) {
        case 'createN2NRelationship':
          return <ConversationToAddressActivityMessage activity={activity} action="create" />;
        case 'deleteN2NRelationship':
          return <ConversationToAddressActivityMessage activity={activity} action="delete" />;
        default:
          return null;
      }
    case 'Behavior':
      switch (activity.activityType) {
        case 'execute':
          return <ExecuteBehaviorActivityMessage activity={activity} />;
        default:
          return null;
      }
    case 'Macro':
      switch (activity.activityType) {
        case 'execute':
          return <ExecuteMacroActivityMessage activity={activity} />;
        default:
          return null;
      }
    case 'LabelAssignment':
      switch (activity.activityType) {
        case 'create':
          return <CreateConversationLabelActivityMessage activity={activity} />;
        case 'delete':
          return <DeleteConversationLabelActivityMessage activity={activity} />;
        default:
          return null;
      }
    default:
      return null;
  }
};
